const apiUrl = 'https://q3rictvewg.execute-api.eu-west-1.amazonaws.com/dev'
const region = 'eu-west-1'

export default {
    Auth: {
        Cognito: {
            userPoolId: 'eu-west-1_UmHAtgs0F',
            identityPoolId: 'eu-west-1:60c117ac-fa1d-46cf-b1d0-0081298363eb',
            userPoolClientId: '25488duspt63cbscf4m88dscnc',
            loginWith: {
                email: true
            }
        }
    },
    API: {
        REST: {
            api: {
                endpoint: apiUrl,
                region
            },
            'open-api': {
                endpoint: apiUrl,
                region
            }
        }
    }
}
